import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-page-share-modal',
  templateUrl: './page-share-modal.component.html',
  styleUrls: ['./page-share-modal.component.scss']
})
export class PageShareModalComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
